import { Fielderror } from './fielderror.model';
import { Httpstatus } from './httpstatus.model';
export class Kernantwort {
  title: string;
  message: string;
  messagehtml: string;
  httpstatus: Httpstatus;
  fieldErrors: Fielderror[];
}